import { ROUTES_SWITCH_CLUB } from '@/constants/routes';

export default {
    path: '/switch-club/:clubId',
    name: ROUTES_SWITCH_CLUB,
    component: () => import(/*webpackChunkName: 'switch-club'*/ '@/components/helpers/SwitchClub')
};
